// mettal-3\src\constants\layout.js
export const BLOCK_DIMENSIONS = {
	LESSON_CARD: {
		HEIGHT: 90,
		GAP: 12,
	},
	LESSONS_BLOCK: {
		HEADER_HEIGHT: 45,
		EXTRA_PADDING: 20,
		COLLAPSED_HEIGHT: 43,
	},
	PRACTICE_CARD: {
		HEIGHT: 90,
		GAP: 12,
	},
	PRACTICE_BLOCK: {
		HEADER_HEIGHT: 45,
		EXTRA_PADDING: 20,
		COLLAPSED_HEIGHT: 45,
	},
	TESTS_CARD: {
		HEIGHT: 90,
		GAP: 12,
	},
	TESTS_BLOCK: {
		HEADER_HEIGHT: 45,
		EXTRA_PADDING: 20,
		COLLAPSED_HEIGHT: 45,
	},
	HOMEWORK_CARD: {
		HEIGHT: 90,
		GAP: 12,
	},
	HOMEWORK_BLOCK: {
		HEADER_HEIGHT: 45,
		EXTRA_PADDING: 20,
		COLLAPSED_HEIGHT: 45,
	},
	MARGINS: {
		LESSONS_TOP: 13,
		PRACTICE: 0,
		TESTS: 30,
		HOMEWORK: 30,
	},
}
